import { useOutletContext } from 'react-router-dom';

export function useFarmContext() {
  return useOutletContext();
}

export default useFarmContext;
